import { GetUtilActivityTypeModel } from "@factory/model/query-model-util-activity-type";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { utilActivityTypeFormDefault } from "./form.default";
import { UtilActivityTypeFormSchema } from "./form.rule";

export const useFormDefaultUtilActivityType = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetUtilActivityTypeModel | undefined) => {
    return !cachedValue
      ? utilActivityTypeFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as UtilActivityTypeFormSchema);
  };

  return {
    getDefault,
  };
};
